import React, { useState, useCallback, useMemo } from "react";
import SidebarContext from "../sidebar-context";
import { defaultContext } from "../sidebar-context/sidebar-context";

import { IProps } from "./sidebar-provider.types";

/**
 * Context provider for sidebar.
 * @param props.children The components that the sidebar will display over.
 * @param props.isOpen   Boolean indicating the initial open status of the sidebar.
 */
const SidebarProvider = ({ children, isOpen: initialIsOpen = false }: IProps) => {
    const [isOpen, setIsOpen] = useState(initialIsOpen);

    /**
     * Close the sidebar.
     */
    const hideSidebar = useCallback(() => {
        setIsOpen(false);
    }, []);

    /**
     * Open the sidebar.
     */
    const showSidebar = useCallback(() => {
        setIsOpen(true);
    }, []);

    const context = useMemo(
        () => ({
            ...defaultContext,
            isOpen,
            hideSidebar,
            showSidebar,
        }),
        [hideSidebar, showSidebar, isOpen]
    );

    return <SidebarContext.Provider value={context}>{children}</SidebarContext.Provider>;
};

export default SidebarProvider;
